<div
  data-test="SsVSGCQB"
  class="tabs__item"
  [class.active]="active"
  [class.disable]="disabled"
  #container
>
  <ng-content></ng-content>
</div>
